export const dateRegExp = /^(0[1-9]|1[012])[-]([012][0-9]|3[01])[-]([0-9]{4})$/;

export const hexRegExp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export const phoneNumberRegExp = /^\+[0-9]{11}$/;
export const numberRegExp = /^[+]?[0-9]*$/;

export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const guidRegex =
  /^[{]?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}[}]?$/;

export const unixTimestampRegex = /^\d{13}$/;
